import isEmpty from './is-empty.js';

export default function isNotEmpty(value) {
  return !isEmpty(value);
}
